export const GET_CONTEXT_NULL = "Cannot read properties of null (reading 'getContext')";
export const INVALID_ADDRESS = 'Provided address is invalid';
